// Typesafe not null function
export function notNull<TValue>(
	value: TValue | null | undefined,
): value is TValue {
	return !(value === null || value === undefined);
}

// Typesafe not truthy function
export function notTruthy<TValue>(
	value: TValue | null | undefined | false,
): value is TValue {
	return !(value === null || value === undefined || value === false);
}

export function areStringsEqual(a: string[], b: string[]) {
	if (a.length !== b.length) return false;
	return a.every((value, index) => value === b[index]);
}
